import React from 'react'
import dynamic from 'next/dynamic'
import { ELanguage } from '@microfrontends/react-components'

const OperationEcommerce = dynamic(async () => await import('./operation-ecommerce'))
const RefundPolicy = dynamic(async () => await import('./refund-policy'))

// New Static page should be in this map
// Define a mapping of slug to components
export const pageMap: Record<string, React.ComponentType> = {
    // operation-ecommerce
    'operation-ecommerce': OperationEcommerce,
    'quy-che-hoat-dong-thuong-mai-dien-tu': OperationEcommerce,
    // refund-policy
    'refund-policy': RefundPolicy,
    'chinh-sach-hoan-tien': RefundPolicy
}

export const pageLanguage: Record<string, ELanguage> = {
    // operation-ecommerce
    'operation-ecommerce': ELanguage.EN,
    'quy-che-hoat-dong-thuong-mai-dien-tu': ELanguage.VI,
    // refund-policy
    'refund-policy': ELanguage.EN,
    'chinh-sach-hoan-tien': ELanguage.VI
}
